import React, { Component } from 'react';
import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';

class LocalStorage extends Component {

  constructor (props) {
    super(props);

    this.webStorage = window.localStorage;
  }

  render() {
    if (!isNil(this.props.store)) {
      this.save(this.props.store)
    }

    if (this.props.onRetrieve) {
      this.props.onRetrieve(this.retrieve(this.props.retrieve));
    }

    return (
      <div id="aaLocalStorage"></div>
    );
  }

  save(object) {
    const now = new Date();

    if (isNil(object.key && object.val)) return;

    if (isObject(object.val)) {
      object.val = JSON.stringify(object.val);
    }

    this.webStorage.setItem(object.key, object.val);
    this.webStorage.setItem(object.key + '_timestamp', now);
  }

  retrieve(key) {
    return this.webStorage.getItem(key);
  }

  remove(key) {
    this.webStorage.removeItem(key);
    this.webStorage.removeItem(key + '_timestamp');
  }

  clearAll() {
    this.webStorage.clear();
  }
}

export default LocalStorage;



// WEBPACK FOOTER //
// ./src/components/framework/LocalStorage.js